<template>
  <div>
     <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg  shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="w-full p-3 font-bold text-xl hover:bg-blue-400 mt-1 bg-blue-600 text-white rounded shadow"
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="flex justify-between p-8 text-sm border-t border-gray-300 bg-gray-100"
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>
    <div v-if="numero" class="bg-gray-100 grid justify-items-start">
      <button
        class="bg-blue-500 text-white col-start-1 mt-7 border-blue-100 rounded col-span-1 p-2 m-4"
      >
        <a href="#modalConsecutivo">
          <STRONG class="text-xl shadow-2xl">+</STRONG> Agregar
        </a>
      </button>

      <modalConsecutivo></modalConsecutivo>
      <tablaConsecutivo></tablaConsecutivo>
      
    </div>
  </div>
</template>

<script>
import modalConsecutivo from "../components/modales/modalConsecutivo";
import tablaConsecutivo from "../components/Tablas/tablaConsecutivo.vue";
import { mapState } from "vuex";

export default {
  name: "consecutivo",
  data(){
    return{
      falso:false
    }
  },
  components: {
    modalConsecutivo,
    tablaConsecutivo,
  },
  computed:{
    ...mapState(['numero'])
  },


};
</script>

<style>
</style>